export default __webpack_public_path__ + "static/client_back-5f9a4db487b0af31161fe713f4893f68.webp";